import { theme } from '../globalStyle/global-styles';
import styled from 'styled-components';

export const FormEditWrapper = styled.div`
  form {
    max-height: 470px;
    overflow-y: scroll;
    border-bottom: 1px solid ${theme.colours.BrightGray};
    border-top: 1px solid ${theme.colours.BrightGray};
    padding: 8px 14px;
    margin-top: 20px;
    p {
      font-size: 13px;
      font-family: ${theme.fonts.Regular};
      color: ${theme.colours.gray2};
      margin-bottom: 6px;
    }
    input {
      &:lang(ar) {
        text-align: right;
      }
      border-color: ${theme.colours.BrightGray};
      background-color: ${theme.colours.Lotion};
      border-radius: 12px;
      height: 40px;
      width: 100%;
      font-family: ${theme.fonts.Medium};
      font-size: 14px;
      color: ${theme.colours.black};
      padding: 12px 20px;
      &[type='search'] {
        /* background-color: #fff; */
      }
    }
    .mantine-MultiSelect-input {
      padding-right: 20px;
    }
    .mantine-MultiSelect-wrapper {
      input {
        border: none;
      }
    }
    .mantine-NumberInput-rightSection,
    .mantine-Select-rightSection,
    .mantine-MultiSelect-rightSection {
      display: none;
    }

    /* Scroll */
    ::-webkit-scrollbar {
      width: 4px;
    }

    ::-webkit-scrollbar-track {
      background-color: #eaeaea;
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${theme.colours.BrightGray2};
      border-radius: 4px;
    }
  }
  .action_container {
    padding: 16px 0;
    button {
      border-radius: 12px;
      min-width: 85px;
      height: 36px;
      background-color: ${theme.colours.AntiFlashWhite};
      color: ${theme.colours.black};
      font-weight: 400;
      &[type='submit'] {
        background-color: ${theme.colours.mainBlue};
        color: #fff;
        width: 158px;
      }
      @media (max-width: 767px) {
        width: 50% !important;
      }
    }
  }
`;
